import { setTerm } from './helpers';

export const setHasFlatTourBooking = setTerm('has_decoration');
